<template>
  <div class="advanced-video-selector is-flex is-flex-direction-column">
    <div class="px-5 py-3">

      <!-- Host control toggle -->
      <!-- <div class="is-flex is-justify-content-space-between px-5 py-3">
      <div v-if="$parent.hostControl && !isHost">
        {{ $t('exp_videoSelector.selectedByHost') }}
      </div>
      <div v-else>{{ $t('exp_videoSelector.chooseCard') }}</div>
      <div v-if="isHost" class="is-flex">
        <b-switch size="is-small" class="has-text-weight-bold" v-model="$parent.hostControl"
          @click.native='$parent.ToggleHostControl()'>
          <d-icon icon="FaUsers" size="is-small" :class="{ 'has-text-primary': $parent.hostControl }" />
        </b-switch>
      </div>
    </div> -->

      <!-- Search box -->
      <b-field>
        <b-input placeholder="Search..." type="search" v-model="searchQuery">
        </b-input>
      </b-field>

      <!-- Tags -->
      <div class="buttons  is-small mb-3" outlined v-if="tags.length">
        <b-button v-for="tag in tags" :key="tag" size="is-small" :type="selectedTags.includes(tag) ? 'is-primary' : ''"
          @click="toggleTag(tag)">
          {{ tag }}
        </b-button>
      </div>

      <!-- Titulo "search results" -->
      <div v-if="isFiltering" class="is-flex is-justify-content-space-between is-size-7 mb-2"
        style="border-bottom: 1px solid #DBDBDB;">
        <div class="has-text-grey-light">
          RESULTS ({{ filteredVideos.length }})
        </div>
        <div @click="ClearSearch" class="is-bold has-text-weight-bold">
          Clear
        </div>
      </div>

      <!-- Lista -->
      <transition-group name="video-list" tag="div">
        <div v-for="video in filteredVideos" :key="video.id" class="video-list-item my-1 is-flex"
          :class="{ 'video-list-item-active': playing.id == video.id }">
          <b-button class="video-title-button" type="is-primary is-flex-grow-1" @click="OpenInfo(video.id)">
            {{ video.title }}
          </b-button>
          <b-button class="video-play-button" type="is-primary" @click="ChangeVideoAndOpenModal(video.id)"
            :disabled="!isHost && $parent.hostControl">
            <d-icon icon="FaYoutube" />
          </b-button>
        </div>
      </transition-group>

      <!-- Video Info Modal -->
      <b-modal v-model="showInfoModal" @close="selectedVideo = null" :can-cancel="['escape', 'outside']">
        <div class="modal-card advanced-video-info-modal">
          <header class="modal-card-head" style="padding-top: 0; padding-bottom: 0;">
            <div class="is-flex-grow-1"></div>
            <button type="button" class="delete" @click="showInfoModal = false" aria-label="close"></button>
          </header>
          <section class="modal-card-body">

            <div v-if="selectedVideo" class="info-content">
              <div class="has-background-primary-light is-relative"
                :class="{ 'playing': playing.id == selectedVideo.id }" @click="ChangeVideo(selectedVideo.id)">
                <figure class="image is-2by1" v-if="selectedVideo.image" style="transition: all .3s;"
                  :style="{ transform: `scale(${playing.id == selectedVideo.id ? 0.99 : 1})` }">
                  <img :src="selectedVideo.image.sizes?.high?.url || selectedVideo.image.url" />
                </figure>
                <img src="/assets/videoselector/play-circle.png" class="circle-play" />
              </div>

              <div class="control is-size-7" style="flex: 1;">
                <div class="border-bottom-radius p-2 has-text-centered" :class="playing.id == selectedVideo.id
                  ? 'has-background-primary-light has-text-white-bis has-text-weight-bold'
                  : 'has-background-grey-lighter'" style="border-radius: 0 0 4px 4px;"
                  @click="playing.id != selectedVideo.id && ChangeVideo(selectedVideo.id)">
                  {{ playing.id == selectedVideo.id ? $t('exp_videoSelector.playing') : $t('exp_videoSelector.watchNow')
                  }}
                </div>
              </div>
              <h1 class="is-size-5 mt-2" 
                style="border-bottom: 1px solid #DBDBDB;"
              >{{ selectedVideo?.title }}</h1>

              <b-field class="mt-3 has-text-grey is-size-7">
                {{selectedVideo?.tags?.map(t => t.title || t).join(' / ')}}
                <!-- <b-tag rounded v-for="tag in selectedVideo.tags" :key="tag.id">{{ tag.title }}</b-tag> -->
              </b-field>
              <json-rich-text v-if="selectedVideo.description" :text="selectedVideo.description" />
            </div>
          </section>
          <footer class="modal-card-foot is-justify-content-space-between has-background-white p-2">
            <div class="link-buttons columns is-mobile" v-if="selectedVideo?.buttons?.length">
              <div v-for="(button, index) in selectedVideo.buttons" class="column"
                :class="buttonClass(selectedVideo.buttons.length, index)" :key="button.id || index">
                <a :href="GetFullUrl(button.link)" class="button is-fullwidth is-primary is-outlined" target="_blank"
                  @click="$TrackUserEvent('Video External Link Clicked', {
                    video_id: selectedVideo.id,
                    video_title: selectedVideo.title,
                    button_label: button.label,
                    button_link: button.link
                  })">
                  <d-icon v-if="button.icon" :icon="button.icon" size="is-small" class="mr-1" />
                  {{ button.label }}
                </a>
              </div>
            </div>

          </footer>
        </div>
      </b-modal>

      <b-modal v-model="promptConfirm.show" has-modal-card :can-cancel="false">
        <div class="modal-card m-4 has-text-centered" style="width: auto">
          <header class="card-header has-background-white-bis">
            <p class="card-header-title is-justify-content-center" v-html="$t('exp_videoSelector.youWantToChange')"></p>
          </header>
          <section class="modal-card-body has-background-light pb-3">
            <div class="is-flex is-flex-direction-column is-justify-content-center">
              <div v-html="$t('exp_videoSelector.theseUsersAreWatching')"></div>
              <div class="playerlist mt-3 px-5">
                <player-avatar v-for="player in players" :player="player" :key="player.id" :scale="2"
                  :showUsername="true" :horizontal="true" class="mb-2" />
              </div>
            </div>

          </section>
          <footer class="modal-card-foot is-justify-content-end">
            <b-button :label="$t('system.cancel')" type="is-primary is-outlined has-background-white-bis"
              size="is-small" expanded @click="promptConfirm.show = false" />
            <b-button :label="$t('exp_videoSelector.playNow')" type="is-primary" size="is-small" expanded
              @click="PlayVideo(promptConfirm.videoId); promptConfirm.show = false" />
          </footer>
        </div>
      </b-modal>

      <b-modal v-model="showNotAllowVideo" has-modal-card :can-cancel="false">
        <div class="modal-card m-4 has-text-centered" style="width: auto">
          <header class="card-header has-background-white-bis">
            <p class="card-header-title is-justify-content-center" v-html="$t('exp_videoSelector.dontAllowChange')"></p>
          </header>
          <section class="modal-card-body has-background-light pb-3">
            <div class="is-flex is-flex-direction-column is-justify-content-center">
              <div v-html="$t('exp_videoSelector.dontAllowChangeDescription')"></div>
            </div>
          </section>
          <footer class="modal-card-foot is-justify-content-end">
            <b-button :label="$t('system.close')" type="is-primary" size="is-small" expanded
              @click="showNotAllowVideo = false" />
          </footer>
        </div>

      </b-modal>



    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import JsonRichText from '../JsonRichText.vue';
import 'vue-glide-js/dist/vue-glide.css';
import { Glide, GlideSlide } from 'vue-glide-js';
import './AdvancedVideoSelector.scss';
import PlayerAvatar from '../PlayerAvatar.vue';

export default {
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
    JsonRichText,
    PlayerAvatar,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      arrowsTop: 0,
      activeSlide: 0,
      videos: [],
      playing: {
        index: null,
        id: null
      },
      allowGuestsToInterruptVideos: false,
      showNotAllowVideo: false,
      promptConfirm: {
        show: false,
        videoId: undefined,
      },
      sliderId: 0, // al cambiarlo fuerzo al slider a rerenderizarse

      searchQuery: "",
      debouncedSearchQuery: "",
      searchDebounceTimer: null,
      tags: [],
      selectedTags: [],
      selectedVideo: null,
      showInfoModal: false,
      pendingPlayingVideo: null,
    };
  },
  computed: {
    isFiltering() {
      return this.searchQuery || this.selectedTags.length > 0;
    },
    players() {
      // Jugadores que no sean yo. Máximo 5
      return this.$store.state.user.players
        .filter(x => x.dbid != this.$store.state.user.profile.id)
        .slice(0, 5);
    },
    isHost() {
      return this.$store.getters["user/hasAdminAuthority"]
    },
    EnableSwipe() {
      const defaultValue = 80;
      if (this.isHost) return defaultValue;
      if (this.$parent.hostControl) return false;
      return defaultValue;
    },
    filteredVideos() {
      return this.filterVideos(this.debouncedSearchQuery, this.videos, this.selectedTags);
    },
  },
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler(newOptions) {
        this.applyOptions(newOptions);
      },
    },
    EnableSwipe(newState, oldState) {
      if (newState != oldState) {
        this.sliderId++
      }
    },
    searchQuery(newValue) {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      this.searchDebounceTimer = setTimeout(() => {
        this.debouncedSearchQuery = newValue;
        
        // Track search performed (only when there's a query)
        if (newValue && newValue.trim()) {
          this.$TrackUserEvent("Video Search Performed", {
            search_query: newValue.trim(),
            results_count: this.filterVideos(newValue, this.videos, this.selectedTags).length,
            has_active_tags: this.selectedTags.length > 0,
          });
        }
      }, 250);
    },
    showInfoModal(newVal) {
      if (!newVal) {
        this.selectedVideo = null;
      }
    },
  },
  methods: {
    ClearSearch() {
      this.searchQuery = "";
      this.selectedTags = [];
    },
    applyOptions(options) {
      if (!options) return;
      Object.keys(options).forEach((key) => {
        this[key] = options[key];
      })
      if (this.pendingPlayingVideo) {
        if (this.applyPlayingVideo(this.pendingPlayingVideo)) {
          this.pendingPlayingVideo = null;
        }
      }
    },
    applyPlayingVideo(data) {
      const index = this.videos.findIndex(video => data.videoId == video.id);
      if (index === -1) return false;

      this.playing = { index: index, id: this.videos[index].id };

      if (!this.isHost && this.$parent.hostControl) {
        setTimeout(() => {
          this.activeSlide = index;
        }, 500);
      }
      if (data.selectedByHost) {
        this.$sfxPlay('hostselected');
      }
      return true;
    },
    filterVideos(query, videos, selectedTags = []) {
      let filtered = videos;

      // Filter by selected tags first
      if (selectedTags.length > 0) {
        filtered = filtered.filter((video) => {
          const videoTags = (video.tags || []).map(t => t.title || t);
          return selectedTags.some(tag => videoTags.includes(tag));
        });
      }

      // Then filter by search query
      const normalizedQuery = (query || "").trim().toLowerCase();
      if (!normalizedQuery) return filtered;

      return filtered.filter((video) => {
        const title = (video.title || "").toLowerCase();
        const descriptionText = this.extractText(video.description).toLowerCase();
        const videoTags = (video.tags || []).map(t => {
          const tagTitle = t.title || t;
          return typeof tagTitle === 'string' ? tagTitle.toLowerCase() : '';
        }).join(' ');

        // For description: extract significant words (4+ chars) to reduce noise
        const significantWords = descriptionText
          .split(/\s+/)
          .filter(word => word.length > 3)
          .join(' ');

        return title.includes(normalizedQuery) ||
          significantWords.includes(normalizedQuery) ||
          videoTags.includes(normalizedQuery);
      });
    },
    toggleTag(tag) {
      const index = this.selectedTags.indexOf(tag);
      const action = index > -1 ? 'deselected' : 'selected';
      
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tag);
      }

      // Track tag toggled
      this.$TrackUserEvent("Video Tag Toggled", {
        tag: tag,
        action: action,
        total_selected_tags: this.selectedTags.length,
        results_count: this.filteredVideos.length,
      });
    },
    OpenInfo(videoId) {
      this.selectedVideo = this.videos.find(v => v.id === videoId);
      this.showInfoModal = true;

      // Track video info opened
      this.$TrackUserEvent("Video Info Opened", {
        video_id: videoId,
        video_title: this.selectedVideo?.title,
      });
    },
    extractText(value) {
      if (!value) return "";
      if (typeof value === "string") return value;
      if (Array.isArray(value)) {
        return value.map((item) => this.extractText(item)).join(" ");
      }
      if (typeof value === "object") {
        if (typeof value.text === "string") return value.text;
        return Object.values(value)
          .map((item) => this.extractText(item))
          .join(" ");
      }
      return "";
    },
    GetFullUrl(url) {
      if (!url.includes('://') && !url.startsWith('mailto:') && !url.startsWith('tel:')) {
        url = "//" + url
      }
      return url
    },
    SwipeEnded() {
      // Dejo este callback acá por si lo necesitamos
    },
    buttonClass(buttons, index) {
      if (buttons == 3 && index == 0) return "is-full-mobile";
      if (buttons == 4) return "is-half-mobile";
      return false;
    },
    allowChangeVideo() {
      if (this.$store.state.user.players.length == 1) return true; // estoy solo
      if (this.isHost) return true; // el guia puede hacer lo que quiera
      if (this.playing.id == null) return true; // no hay otro video reproduciendo
      if (this.allowGuestsToInterruptVideos == 'allow') return true; // cualquiera puede cambiar el video
      return false;
    },
    ChangeVideo(id) {
      console.log('🔧 INTERRUMPT OPTION', this.allowGuestsToInterruptVideos)

      if (this.playing.id == id) return
      if (!this.isHost && this.$parent.hostControl) return
      if (this.allowChangeVideo()) {
        console.log('Allow')
        this.PlayVideo(id)
      } else {
        if (this.allowGuestsToInterruptVideos == 'promptFirst') {
          console.log('promp first')
          this.promptConfirm.show = true
          this.promptConfirm.videoId = id
        } else {
          this.showNotAllowVideo = true
        }

        this.$sfxPlay('atentionnotification')

      }
    },
    ChangeVideoAndOpenModal(id) {
      this.ChangeVideo(id);
      this.OpenInfo(id);
    },
    PlayVideo(id) {
      this.$sfxPlay('click')
      console.log("📤 Send gameMessage")
      this.$socket.client.emit('gameMessage', {
        type: "setVideo",
        videoId: id,
        isHost: this.isHost,
      });

      // Track video play
      const video = this.videos.find(v => v.id === id);
      this.$TrackUserEvent("Video Played", {
        video_id: id,
        video_title: video?.title,
        is_host: this.isHost,
        host_control_enabled: this.$parent.hostControl,
        was_filtering: this.isFiltering,
      });
    },
    GoToSlide(index) {
      if (this.$parent.hostControl && !this.isHost) return
      this.activeSlide = index;
    },
    SwipeSlide(dir) {
      if (this.$parent.hostControl && this.isHost)
        if (this.$parent.hostControl && !this.isHost) return
      if (dir == 'next') {
        this.activeSlide++
      } else {
        this.activeSlide--
      }

      if (this.$parent.hostControl && this.isHost) console.log('ahora')
    },
    ChangePlayersSlide(id) {
      console.log("📤  ChangePlayersSlide")
      this.$socket.client.emit('roomPlayersMessage', {
        type: "SetSlide",
        slide: id,
      });
    },
  },
  sockets: {
    SetSlide(data) {
      if (this.isHost) return
      console.log("🔒 SetSlide", data)
      this.activeSlide = data.slide
    },
    playingVideo(data) {
      console.log("📺  PlayVideo", data)
      if (!this.applyPlayingVideo(data)) {
        this.pendingPlayingVideo = data;
      }
    },
    unsetSlide() {
      this.playing = { index: null, id: null }
    }
  },
  async mounted() {
    Object.keys(this.options).forEach((key) => {
      this[key] = this.options[key];
    })

    // Extract unique tag titles from all videos
    const allTags = this.options.videos.flatMap(video =>
      (video.tags || []).map(tag => tag.title || tag)
    );
    this.tags = [...new Set(allTags)].filter(Boolean).sort();

    this.applyOptions(this.options);
    this.$sfxLoad(this.options.sounds,
      [
        'click',
        'atentionnotification',
        'hostselected'
      ]
    )

    this.allowGuestsToInterruptVideos = this.options.config.allowGuestsToInterruptVideos || 'promptFirst';
  },
  beforeDestroy() {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
  },
};
</script>